import clsx from 'clsx'
import React, { ReactNode } from 'react'
import styles from './styles/PageHeader.module.scss'

interface PageHeaderProps {
  title: ReactNode
  description?: ReactNode
  children?: ReactNode
}

export const PageHeader: React.FC<PageHeaderProps> = props => {
  const { title, description, children } = props
  const headingOnly = !description && !children

  return (
    <div className={clsx(styles.container, headingOnly && styles.headingOnly)}>
      {title && typeof title === 'string' && <h2 className={styles.heading}>{title}</h2>}
      {title && typeof title !== 'string' && title}

      {description && typeof description === 'string' && (
        <span className={styles.description} dangerouslySetInnerHTML={{ __html: description }} />
      )}

      {description && typeof description !== 'string' && description}

      {children && children}
    </div>
  )
}

export const PageHeaderTitle: React.FC<{ children: ReactNode }> = ({ children }) => {
  return <h2 className={styles.heading}>{children}</h2>
}
